// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.f8e2lqMl5AI4uS {
  margin-bottom: 20px;
}
.f8e2lqMl5AI4uS .m7L0LYuyIuM5GW {
  display: flex;
  flex-direction: column;
}
.f8e2lqMl5AI4uS .m7L0LYuyIuM5GW .dP3LUGSFk5rifF {
  display: flex;
  align-items: center;
  margin-top: 28px;
  color: var(--ds-text, #172b4d);
  font-size: 20px;
  letter-spacing: -0.008em;
  line-height: 24px;
  font-weight: 600;
}
.f8e2lqMl5AI4uS .m7L0LYuyIuM5GW .dP3LUGSFk5rifF .GRIpCu7j0UUl5k {
  margin-right: 8px;
}
.f8e2lqMl5AI4uS .m7L0LYuyIuM5GW .RWW8K0Lu3Bwdq_ {
  padding-top: 8px;
  font-size: 16px;
}
.f8e2lqMl5AI4uS .m7L0LYuyIuM5GW .f8e2lqMl5AI4uS {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding-top: 24px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"powerUpsContainer": `f8e2lqMl5AI4uS`,
	"powerUpsInner": `m7L0LYuyIuM5GW`,
	"powerUpsHeader": `dP3LUGSFk5rifF`,
	"powerUpsHeaderIcon": `GRIpCu7j0UUl5k`,
	"powerUpsDescription": `RWW8K0Lu3Bwdq_`
};
export default ___CSS_LOADER_EXPORT___;
